import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-mapping-review-coverage',
  standalone: true,
  imports: [],
  templateUrl: './mapping-review-coverage.component.html',
  styleUrl: './mapping-review-coverage.component.scss'
})
export class MappingReviewCoverageComponent {
  @Input() data!: { coverage: string; gaps: string };

  ngOnInit(){
    console.log("MappingReviewCoverageComponent");
    console.log(this.data)
  }
}
